import type { TranslationKey } from '@/i18n-key';

type Translate = (key: TranslationKey, options?: Record<string, unknown>) => string;

/**
 * Deleting a period detaches the objectives that point to it: they keep their own dates and lose
 * the period. Shared by the delete dialog and its test so the count-based wording lives in one
 * place, with a dedicated sentence for the zero case rather than "0 objectif".
 */
export const getObjectivePeriodImpactMessage = (
    t: Translate,
    // `undefined` only ever happens while the dialog's `period` prop is still null; the field is
    // always present once a period exists.
    linkedObjectivesCount: number | undefined,
): string => {
    if (!linkedObjectivesCount || linkedObjectivesCount <= 0) {
        return t('objectivePeriods.impactNone');
    }

    return t('objectivePeriods.impactCount', { count: linkedObjectivesCount });
};
